import { Box, Stack, Tooltip, Typography } from "@mui/material";

import { InfoOutlinedIcon } from "@/icons";
import OrionSwitch from "@/orion/OrionComponents/OrionSwitch";

export interface AbTestToggleProps {
  /** Whether A/B testing is currently on (derived from variations.length > 1). */
  checked: boolean;
  /** Called with the next enabled state when the user flips the switch. */
  onChange: (enabled: boolean) => void;
  disabled?: boolean;
}

/**
 * Labeled switch that turns A/B testing on/off for a broadcast. Presentational
 * only — the owning form decides what "on"/"off" does (add vs. remove a
 * variation), since A/B is derived from the variation count.
 */
export function AbTestToggle({
  checked,
  onChange,
  disabled,
}: AbTestToggleProps) {
  return (
    <Stack direction="row" alignItems="center" gap={3}>
      <OrionSwitch
        checked={checked}
        disabled={disabled}
        onChange={(_event, next) => onChange(next)}
        inputProps={{ "aria-label": "Enable A/B Winner" }}
      />
      <Typography variant="body1">Enable A/B Winner</Typography>
      <Tooltip
        title="Send variants to a sample of your audience, then automatically deliver the top performer to everyone else"
        arrow
      >
        <Box
          component="span"
          sx={{ display: "inline-flex", alignItems: "center" }}
        >
          <InfoOutlinedIcon
            sx={{ fontSize: 18, color: "text.secondary", cursor: "pointer" }}
          />
        </Box>
      </Tooltip>
    </Stack>
  );
}
